import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Heading } from '@chakra-ui/react';
import { CaretRightIcon } from '@udacity/chakra-uds-icons';

import { ContentContainer } from '~/components/container';
import { SanityImage } from '~/components/sanity-image';
import { SanityImageType } from '~/features/page-template/models/image';

export function CaseStudyHero({
  companyLogo,
  companyName,
  heroImage,
  title,
}: {
  companyLogo: SanityImageType;
  companyName: string;
  heroImage: SanityImageType;
  title: string;
}) {
  return (
    <Box background='linear-gradient(180deg, rgba(0, 1, 17, 0.9) 0%, rgba(23, 26, 83, 0.7) 100%);' position='relative'>
      <ContentContainer
        alignContent='center'
        display='flex'
        justifyContent='center'
        paddingY={{ base: '80px', md: '180px' }}
      >
        <Box maxWidth='content-max-width-lg' position='relative' zIndex={2}>
          <Breadcrumb
            position='relative'
            separator={<CaretRightIcon color='white' h='32px' w='32px' />}
            spacing={1}
            listProps={{
              flexWrap: 'wrap',
              gap: '4px',
              justifyContent: 'center',
            }}
          >
            <BreadcrumbItem>
              <BreadcrumbLink color='accent.lime !important' href='/resource-center'>
                Case Studies
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink color='white !important'>{companyName}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          <Heading
            as='h1'
            color='white'
            display={{ base: 'none', md: 'block' }}
            marginTop='24px'
            size='marketing-5xl'
            textAlign='center'
          >
            {title}
          </Heading>

          <Heading
            as='h1'
            color='white'
            display={{ base: 'block', md: 'none' }}
            marginTop='24px'
            size='marketing-3xl'
            textAlign='center'
          >
            {title}
          </Heading>

          <Box display='flex' justifyContent='center' marginTop='40px'>
            <SanityImage image={companyLogo} priority={true} sizes='140px' style={{ width: '140px' }} />
          </Box>
        </Box>
      </ContentContainer>

      <SanityImage
        fill={true}
        image={heroImage}
        priority={true}
        style={{
          objectFit: 'cover',
          objectPosition: 'center',
          zIndex: -1,
        }}
      />
    </Box>
  );
}
